import type { ButtonHTMLAttributes, ReactNode } from 'react';
type Kind = 'primary' | 'default' | 'danger' | 'ghost';
type Size = 'sm' | 'md';
const KIND: Record<Kind, string> = {
  primary:
    'bg-primary text-white hover:bg-primary-dark shadow-sm shadow-primary/10 hover:shadow-md hover:shadow-primary/20 active:scale-[0.98] active:translate-y-[0.5px] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-primary/30 transition-all duration-100',
  default:
    'bg-surface text-ink border border-line hover:border-ink-3 hover:bg-bg-warm active:scale-[0.98] active:translate-y-[0.5px] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-ink-3/20 transition-all duration-100',
  danger:
    'bg-danger text-white hover:bg-danger/90 shadow-sm shadow-danger/10 hover:shadow-md hover:shadow-danger/20 active:scale-[0.98] active:translate-y-[0.5px] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-danger/30 transition-all duration-100',
  ghost:
    'bg-transparent text-ink-2 hover:bg-bg-warm hover:text-ink active:scale-[0.98] active:translate-y-[0.5px] focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-ink-3/20 transition-all duration-100',
};
const SIZE: Record<Size, string> = {
  sm: 'h-8 px-3 text-sm-label',
  md: 'h-10 px-4 text-body',
};
export function Btn({
  kind = 'default',
  size = 'md',
  icon,
  children,
  className = '',
  ...rest
}: {
  kind?: Kind;
  size?: Size;
  icon?: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-btn font-bold justify-center disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none disabled:active:scale-100 disabled:active:translate-y-0 ${KIND[kind]} ${SIZE[size]} ${className}`}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
